import {flint} from './request'
import {create} from './debug'
import get from 'lodash/get'

const log = create('flint')

let config = {}

const init = () => {
    // flint.get('api/v1/apps/meme/h5_2339_com').then((res) => {
    //     log(res)
    //     config = res.data;
    // })
}


const _get = (path) => {
    return get(config,path);
}

export default {
    init,
    get:_get
};
